export default function IconShield({ size = 20 }: { size?: number }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <g fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round">
        <path d="M12 3.5 5 6v5.5c0 4.5 2.9 7.5 7 9 4.1-1.5 7-4.5 7-9V6z" />
        <path strokeLinecap="round" d="m9.5 12 1.8 1.8 3.2-3.6" />
      </g>
    </svg>
  );
}
